import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const addAdminBom = createAsyncThunk(
    "/admin/add-bom",
    async (payload) => {
        try {
            const myurl = `${V_URL}/believe/create-bom`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to create BOM");
            }
        } catch (error) {
            console.error("Error in addAdminBom:", error);
            toast.error(error.response?.data?.message || "Failed to create BOM");
            throw error;
        }
    }
);

const addAdminBomSlice = createSlice({
    name: "addAdminBom",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addAdminBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAdminBom.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(addAdminBom.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default addAdminBomSlice.reducer;
